import { createSelector } from '@reduxjs/toolkit';
import { identity, selectFeature, SELECTOR, selectSplitStatus, setSelector } from '@socialive/common';

const selectHasFeatureLoaded = (featureLike) =>
  createSelector(identity, (state) => {
    const { complete, timedOut } = selectSplitStatus(state);
    if (complete) {
      const [treatment] = selectFeature(featureLike)(state);
      return treatment !== 'control' || timedOut;
    }
    return complete;
  });

setSelector(SELECTOR.SPLIT_HAS_FEATURE_LOADED, selectHasFeatureLoaded);

export default selectHasFeatureLoaded;
